<template>
  <span class="logo">
    <img src="../assets/img/logo-black-white.svg" height="32" />
    <span class="logo-code">code</span>
    <span class="logo-img">img</span>
    <span class="badge badge-soft-warning">beta</span>
  </span>
</template>

<script>
export default {
  name: "logo"
};
</script>

<style scoped>
.logo {
  font-size: 1.5rem;
}
img {
  margin-right: 0.5rem;
}
.logo-code {
  color: #002240;
}

.logo-img {
  color: #ff5f56;
}
.badge {
  margin-left: 0.5rem;
  font-size: 50%;
}
</style>
